import * as React from 'react';
import { chunk } from 'lodash-es';
import { withStyles, WithStyles, createStyles } from '@material-ui/core';
import Link from 'ha/ui/next/Link';
import Grid from 'ha/ui/next/Grid';
import Paper from 'ha/ui/next/Paper';
import units from 'ha/theme/units';
import { Suggestion } from '../../types';
import { DefaultSuggestionsItemsCount } from '../../constants';

import { SliderWithControls } from 'ha/components/next/Slider';

export const styles = createStyles({
  wrapper: {
    overflowX: 'auto',
    padding: units.rem('0.5'),
  },
  card: {
    fontSize: units.rem('1'),
    lineHeight: units.rem('1.875'),
    width: units.rem('15'),
    height: '100%',
    minHeight: units.rem('17'),
    padding: units.trbl(1, 0, 1.25, 1.5),
    marginRight: units.rem('0.75'),
  },
  cityName: {
    fontWeight: 'bold',
  },
});

interface Props {
  list: Suggestion[];
  itemsCount?: number;
}

export const MobileSuggestions: React.SFC<
  Props & WithStyles<typeof styles>
> = ({ list, itemsCount = DefaultSuggestionsItemsCount, classes }) => {
  const chunks = chunk(list, itemsCount);

  return (
    <Grid container wrap="nowrap" className={classes.wrapper}>
      <SliderWithControls
        containerStyle={{
          width: units.rem(16.25),
          overflowX: 'visible',
        }}
        slideStyle={{
          padding: units.rem(0.5),
        }}
      >
        {chunks.map((item, index) => (
          <Grid item key={index} data-test-locator="Suggestion Group">
            <Paper className={classes.card}>
              {item.map(({ searchUrl, cityLocalized, countryLocalized }) => (
                <div key={searchUrl} data-test-locator="Suggestion Item">
                  <Link
                    to={searchUrl}
                    kind="hover-underline"
                    title={`${cityLocalized}, ${countryLocalized}`}
                  >
                    <span className={classes.cityName}>{cityLocalized}</span>
                    <span>, {countryLocalized}</span>
                  </Link>
                </div>
              ))}
            </Paper>
          </Grid>
        ))}
      </SliderWithControls>
    </Grid>
  );
};

export default withStyles(styles)(MobileSuggestions);
